import { render, staticRenderFns } from "./UserErrorCorrection.vue?vue&type=template&id=676935c2&scoped=true"
import script from "./UserErrorCorrection.vue?vue&type=script&lang=js"
export * from "./UserErrorCorrection.vue?vue&type=script&lang=js"
import style0 from "./UserErrorCorrection.vue?vue&type=style&index=0&id=676935c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676935c2",
  null
  
)

export default component.exports